import styled, { css, keyframes } from 'styled-components';
import { IProgressIndicatorProps } from './progress-indicator-props';
import { isIndeterminate } from './utils';

const progressIndicatorSize = { small: 150, medium: 300, large: 600 };

export const ProgressIndicatorWrapper = styled.div.attrs(() => ({
    className: String('ap-progressIndicator-wrapper')
})) <Pick<IProgressIndicatorProps, 'size'>>`
    width: ${({ size }) => progressIndicatorSize[size!]}px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
`;

export const ProgressBar = styled.div.attrs(() => ({
    className: String('ap-progressIndicator-progressBar')
})) <Pick<IProgressIndicatorProps, 'showPercentage' | 'progressIndicatorType'>>`
    width: ${({ showPercentage }) => (showPercentage ? 'calc(100% - 50px)' : '100%')};
    display: inline-block;
    height: 5px;
    position: relative;
    overflow: hidden;
    background-color: ${({ theme: { progressIndicator }, progressIndicatorType }) =>
        (isIndeterminate(progressIndicatorType) ? progressIndicator.colors.Indeterminate.backgroundColor : progressIndicator.colors.determinate.backgroundColor)};
    border-radius: 50px;
`;

export const Progress = styled.span.attrs(() => ({
    className: String('ap-progressIndicator-progress')
})) <Pick<IProgressIndicatorProps, 'progress' | 'progressIndicatorType'>>`
    position: absolute;
    height: 100%;
    border-radius: 50px;
    ${({ progressIndicatorType }) =>
        (isIndeterminate(progressIndicatorType) ? indeterminateStyle : determinateStyle)};
`;

const determinateStyle = css<Pick<IProgressIndicatorProps, 'progress'>>`
    background-color: ${({ theme: { progressIndicator } }) => progressIndicator.colors.determinate.progressIndicatorColor};
    width: ${({ progress }) => progress}%;
    transition: width 150ms ease-out;
`;

const inDeterminateAnimation = keyframes`
    from { left: -30%; }
    to { left: 100%; }
`;

const indeterminateStyle = css`
    background: ${({ theme: { progressIndicator } }) => progressIndicator.colors.Indeterminate.progressIndicatorColor};
    width: 40%;
    animation: ${inDeterminateAnimation} 2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    animation-iteration-count: infinite;
`;

export const ProgressPercentage = styled.div.attrs(() => ({
    className: String('ap-progressIndicator-progressPercentage')
}))`
    color:  ${({ theme: { progressIndicator } }) => progressIndicator.colors.determinate.progressIndicatorColor};
    display: inline-block;
    line-height: 20px;
    min-width: 50px;
    text-align: center;
`;
